import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import AuthGuard from './components/AuthGuard';
import AppShell from './components/AppShell';
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import EmployersPage from './pages/EmployersPage';
import EmployerDetailPage from './pages/EmployerDetailPage';
import WorkersPage from './pages/WorkersPage';
import WorkerDetailPage from './pages/WorkerDetailPage';
import RevenuePage from './pages/RevenuePage';
import FeatureFlagsPage from './pages/FeatureFlagsPage';
import CitiesPage from './pages/CitiesPage';
import AmbassadorsPage from './pages/AmbassadorsPage';
import AmbassadorDetailPage from './pages/AmbassadorDetailPage';
import ReferralReviewsPage from './pages/ReferralReviewsPage';
import RatingConsistencyReviewsPage from './pages/RatingConsistencyReviewsPage';
import ContentReportsPage from './pages/ContentReportsPage';
import OnboardingQuestionsPage from './pages/OnboardingQuestionsPage';
import GuestPreviewPage from './pages/GuestPreviewPage';
import SecurityPage from './pages/SecurityPage';

function ProtectedPage({ children }) {
  return (
    <AuthGuard>
      <AppShell>
        {children}
      </AppShell>
    </AuthGuard>
  );
}

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="/dashboard" element={<ProtectedPage><DashboardPage /></ProtectedPage>} />
          <Route path="/employers" element={<ProtectedPage><EmployersPage /></ProtectedPage>} />
          <Route path="/employers/:uid" element={<ProtectedPage><EmployerDetailPage /></ProtectedPage>} />
          <Route path="/workers" element={<ProtectedPage><WorkersPage /></ProtectedPage>} />
          <Route path="/workers/:uid" element={<ProtectedPage><WorkerDetailPage /></ProtectedPage>} />
          <Route path="/revenue" element={<ProtectedPage><RevenuePage /></ProtectedPage>} />
          <Route path="/feature-flags" element={<ProtectedPage><FeatureFlagsPage /></ProtectedPage>} />
          <Route path="/cities" element={<ProtectedPage><CitiesPage /></ProtectedPage>} />
          <Route path="/ambassadors" element={<ProtectedPage><AmbassadorsPage /></ProtectedPage>} />
          <Route path="/ambassadors/:uid" element={<ProtectedPage><AmbassadorDetailPage /></ProtectedPage>} />
          <Route path="/referral-reviews" element={<ProtectedPage><ReferralReviewsPage /></ProtectedPage>} />
          <Route path="/rating-consistency-reviews" element={<ProtectedPage><RatingConsistencyReviewsPage /></ProtectedPage>} />
          <Route path="/content-reports" element={<ProtectedPage><ContentReportsPage /></ProtectedPage>} />
          <Route path="/onboarding-questions" element={<ProtectedPage><OnboardingQuestionsPage /></ProtectedPage>} />
          <Route path="/guest-preview" element={<ProtectedPage><GuestPreviewPage /></ProtectedPage>} />
          <Route path="/security" element={<ProtectedPage><SecurityPage /></ProtectedPage>} />
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
